import React from 'react';
import { CUSTOM_ACTIONS } from '@/infrastructure/reporter/datong/constant';
import { reportClick } from '@/infrastructure/reporter/datong/report';
import { TopMenuButton } from '@/presentation/layouts/header/button';

interface IProps {
  pageId: string;
}
export const OverseasButton = (props: IProps) => {
  const { pageId } = props;
  const onClick = () => {
    reportClick(pageId, CUSTOM_ACTIONS.commonEnterOverseas, {
      from: pageId,
    });
    const a = document.createElement('a');
    a.href = 'https://bugly.tds.tencent.com/v2/index/main';
    a.target = '_blank';
    a.click();
  };
  return <TopMenuButton onClick={onClick}>
    <span>Bugly海外版</span>
  </TopMenuButton>;
};
